import React from 'react';
import { MapPin, Phone, Mail, Linkedin, Twitter, Facebook } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 text-white">
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_smc-nigeria-pro/artifacts/rue3odb3_SMCI%20LOGO.png" 
                alt="SMC International Logo" 
                className="h-28 w-auto object-contain mb-4"
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              {companyInfo.tagline}
            </p>
            <p className="text-gray-400 text-sm">
              Driving Africa's socio-economic development through research, innovation, and strategic excellence.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-amber-400">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'About', 'Services', 'Team', 'Projects', 'Clients', 'Contact'].map((link) => (
                <li key={link}>
                  <button
                    onClick={() => scrollToSection(link.toLowerCase())}
                    className="text-gray-300 hover:text-amber-400 transition-colors text-sm"
                  >
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-amber-400">Our Services</h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Strategy Development</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Program & Project Development</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Legal Advisory</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">ICT Solutions</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Sector Research & Analysis</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Capacity Building</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-amber-400">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="text-amber-400 flex-shrink-0 mt-1" size={18} />
                <p className="text-gray-300 text-sm leading-relaxed">
                  No 3, Indus Close, Wuse II, Abuja, F.C.T-Nigeria
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="text-amber-400 flex-shrink-0" size={18} />
                <a href={`tel:${companyInfo.phone[0].replace(/\s/g, '')}`} className="text-gray-300 hover:text-amber-400 text-sm transition-colors">
                  {companyInfo.phone[0]}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="text-amber-400 flex-shrink-0" size={18} />
                <a href={`mailto:${companyInfo.email}`} className="text-gray-300 hover:text-amber-400 text-sm transition-colors">
                  {companyInfo.email}
                </a>
              </div>
            </div>

            {/* Social Media */}
            <div className="mt-6">
              <h5 className="text-sm font-semibold mb-3 text-amber-400">Follow Us</h5>
              <div className="flex space-x-3">
                <a
                  href="#"
                  className="w-10 h-10 bg-white/10 hover:bg-amber-400 rounded-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                >
                  <Linkedin size={18} />
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-white/10 hover:bg-amber-400 rounded-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                >
                  <Twitter size={18} />
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-white/10 hover:bg-amber-400 rounded-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                >
                  <Facebook size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} Service Management Consultancy Nigeria. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-amber-400 transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-amber-400 transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-amber-400 transition-colors">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
